export const KEYS = {
  driverLicenseCameraStep: 'driverLicenseCameraStep',
  hasCheckedStep: 'hasCheckedStep',
  refillRequiredFields: 'refillRequiredFields',
} as const;
